
(() => {
  const init = () => {
    const header = document.querySelector('.tcl-site-header');
    if (!header || header.dataset.tclSearchV11 === '1') return;

    const form = header.querySelector('.tcl-search');
    const input = form?.querySelector('input[type="search"][name="q"]');
    if (!form || !input) return;

    header.dataset.tclSearchV11 = '1';

    const box = document.createElement('div');
    box.className = 'tcl-v11-search-results';
    box.hidden = true;
    form.parentNode.insertBefore(box, form.nextSibling);

    let timer;
    let controller;

    const close = () => { box.hidden = true; };

    const esc = (s='') => String(s).replace(/[&<>"']/g, c => ({
      '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'
    }[c]));

    input.addEventListener('input', () => {
      clearTimeout(timer);
      const q = input.value.trim();

      if (q.length < 2) {
        if (controller) controller.abort();
        close();
        return;
      }

      timer = setTimeout(async () => {
        if (controller) controller.abort();
        controller = new AbortController();

        try {
          const url = `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=hide`;
          const res = await fetch(url, {
            signal: controller.signal,
            headers: {Accept:'application/json'}
          });
          if (!res.ok) throw new Error('search');
          const data = await res.json();
          const products = data?.resources?.results?.products || [];

          if (!products.length) {
            box.innerHTML = `<div class="tcl-v11-empty">Geen producten gevonden voor “${esc(q)}”.</div>`;
          } else {
            box.innerHTML = products.map(p => `
              <a class="tcl-v11-result" href="${esc(p.url)}">
                ${p.image ? `<img src="${esc(p.image)}" alt="" loading="lazy">` : '<span></span>'}
                <span class="tcl-v11-copy">
                  <strong>${esc(p.title)}</strong>
                  ${p.vendor ? `<small>${esc(p.vendor)}</small>` : ''}
                </span>
                ${p.price ? `<b>${esc(p.price)}</b>` : ''}
              </a>
            `).join('') + `<a class="tcl-v11-all" href="/search?q=${encodeURIComponent(q)}&type=product">Bekijk alle zoekresultaten →</a>`;
          }
          box.hidden = false;
        } catch (e) {
          if (e.name !== 'AbortError') close();
        }
      }, 200);
    });

    document.addEventListener('click', e => {
      if (!form.parentNode.contains(e.target)) close();
    });
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape') close();
    });
  };

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
